/* eslint-disable react/display-name */
import { Redirect } from 'react-router-dom';
import PharmacyList from './pharmacy-list-management/pharmacy-list';
import PharmacyAdd from './pharmacy-list-management/pharmacy-add';
import PharmacyEditWrapper from './pharmacy-list-management/pharmacy-edit-wrapper/pharmacy-edit-wrapper';

/* Pharmacy User */
import PharmacyUserAdd from './pharmacy-list-management/pharmacy-user-management/pharmacy-user-add';
import PharmacyUserEdit from './pharmacy-list-management/pharmacy-user-management/pharmacy-user-edit';

/* Pharmacy Support */
import PharmacySupportFormList from './pharmacy-support/pharmacy-support-list';
import { ComingSoonCard } from 'app/components/atoms';

const PharmacyManagementConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/pharmacy-management/pharmacy-list',
      component: PharmacyList,
      title: 'Eczane Listesi - Eczane Yönetimi ',
      isAuthProtected: true
    },
    {
      path: '/pharmacy-management/add-pharmacy',
      component: PharmacyAdd,
      title: 'Eczane Ekle - Eczane Yönetimi ',
      isAuthProtected: true
    },
    {
      path: '/pharmacy-management/:id/edit-pharmacy',
      component: PharmacyEditWrapper,
      title: 'Eczane Güncelle - Eczane Yönetimi ',
      isAuthProtected: true
    },
    {
      path: '/pharmacy-management/:id/pharmacy-users-list',
      component: PharmacyEditWrapper,
      title: 'Eczane Kullanıcıları Listesi - Eczane Yönetimi ',
      isAuthProtected: true
    },
    {
      path: '/pharmacy-management/:id/add-pharmacy-user',
      component: PharmacyUserAdd,
      title: 'Eczane Kullanıcısı Ekle - Eczane Yönetimi ',
      isAuthProtected: true
    },
    {
      path: '/pharmacy-management/:id/edit-pharmacy-user/:userId',
      component: PharmacyUserEdit,
      title: 'Eczane Kullanıcısı Güncelle - Eczane Yönetimi ',
      isAuthProtected: true
    },
    /* Pharmacy On Duty Pages */

    {
      path: '/pharmacy-on-duty-management/pharmacy-on-duty-list',
      component: ComingSoonCard,
      title: 'Nöbetçi Eczaneler Listesi',
      isAuthProtected: true
    },

    /* Pharmacy - Support Forms */
    {
      path: '/pharmacy-support/pharmacy-support-list',
      component: PharmacySupportFormList,
      title: 'Eczane Müşterisi Destek',
      isAuthProtected: true
    },

    {
      path: '/pharmacy-management',
      component: () => <Redirect to="/pharmacy-management/pharmacy-list" />
    }
  ]
};

export default PharmacyManagementConfig;
